import { render, staticRenderFns } from "./IconPreviewUpload.vue?vue&type=template&id=73eb83c4&scoped=true"
import script from "./IconPreviewUpload.vue?vue&type=script&lang=js"
export * from "./IconPreviewUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eb83c4",
  null
  
)

export default component.exports